import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7fc3a9ca"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "accept-invite-page d-flex align-items-center justify-content-center text-center" }
const _hoisted_2 = { class: "container p-4" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "px-4 py-2 fs-6" }, "Accept Invite", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_action_button = _resolveComponent("action-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", null, "You have been invited to collaborate on " + _toDisplayString(_ctx.invite.board), 1),
      _createVNode(_component_action_button, {
        class: "mx-auto btn-primary-1",
        disabled: _ctx.isInviting,
        onClick: _ctx.handleInvite
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }, 8, ["disabled", "onClick"])
    ])
  ]))
}